import { ICauHinhHeThong } from 'src/types/CauHinhHeThong.type';
import BaseService from './base.service';

export default class CauHinhHeThongService extends BaseService<ICauHinhHeThong> {
  constructor() {
    super('/cau-hinh-he-thong');
  }
}
